import { Component, OnDestroy, OnInit } from '@angular/core';

import { TimeEntryBus } from '@app/cp/shared/models/TimeEntryBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { EmployeeService } from '@app/cp/shared/services/employee.service';
import { Subscription, timer } from 'rxjs';

import { DateFunctions } from '../../shared/static/date-functions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
  selector: 'clock-in-out',
  templateUrl: './clock-in-out.component.html',
  styleUrls: ['./clock-in-out.component.scss']
})
export class ClockInOutComponent implements OnInit, OnDestroy {
    constructor(private svc_data: EmployeeService, private globals: GlobalsService) {

    }
    personId: any;
    timeEntryId: any;
    clockedIn: boolean = false;
    subs_data: Subscription;
    dataGrid: TimeEntryBus[];
    dataLoading: boolean = false;
    totalHrs: Number = 0;
    durationString: String = "";
    clockInTimedatetime: Date;
    clockRefresh: any;
    saving: boolean = false;
    dialogOpened: boolean = false;
    subs_waivers: Subscription;
    subs_saveWaivers: Subscription
    userWaiver = null;
    selectedValue = null;
    CAWaiverId = '529F293B-DB91-483B-B324-3938E68BFB71';
    ngOnInit() {
        this.personId = this.globals.personId;
        this.getTimeEntries();
        this.dialogOpened = false;
        this.checkForUserWaivers();

    }

    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_data);
    }
    selectValue(event, value) {
        if(!event.target.checked){
            this.selectedValue = null;
        } else {
            this.selectedValue = value;
        }
    }

    saveWaivers() {

        if (this.subs_saveWaivers !== undefined && this.subs_saveWaivers !== null) {
            this.subs_waivers.unsubscribe();
        }
        this.subs_saveWaivers = this.svc_data.saveWaiverResponse(this.CAWaiverId,this.selectedValue).subscribe((data: BaseMessageInfo) => {
            if (!data.saveError) {
                this.dialogOpened = false;
            }

        });
    }

    checkForUserWaivers() {
        if (this.subs_waivers !== undefined && this.subs_waivers !== null) {
            this.subs_waivers.unsubscribe();
        }
        this.subs_waivers = this.svc_data.checkForUserWaivers(this.CAWaiverId).subscribe((data: BaseMessageInfo) => {
            if (!data.saveError) {
                //                    let data = new DispatchQVBus(info.primaryReturn);
                let curDate = new Date(data.primaryReturn.curDate);
                let lastDate = new Date(data.primaryReturn.lastDate);

                if (data.primaryReturn.waiverNeeded && (curDate > lastDate)) {
                    this.userWaiver = data.primaryReturn.userWaiver;
                    this.dialogOpened = true;
                    this.selectedValue = this.userWaiver.answers[0].value;
                }
            }
        });
    }

    getTimeEntries(): void {
        this.saving = true;

        this.dataLoading = true;
        this.subs_data = this.svc_data.getTimeEntriesCurrentWeek(this.personId).subscribe(data => {
            this.dataLoading = false;
            this.dataGrid = data;
            if (this.dataGrid.length > 0) {
                let entry: TimeEntryBus = this.dataGrid[this.dataGrid.length - 1];
                this.clockedIn = (entry.endTime === null) ? true : false;
                this.timeEntryId = (entry.endTime === null && entry.timeEntryId !== null) ? entry.timeEntryId : null;
                this.timeEntryId = (entry.endTime === null && entry.timeEntryId !== null) ? entry.timeEntryId : null;
                var utcDate = new Date(entry.startTime);
                this.clockInTimedatetime = new Date(Date.UTC(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate(), utcDate.getHours(), utcDate.getMinutes()));
                if (this.clockedIn) {
                    let dateNowin: Date = new Date(Date.now());
                    this.durationString = DateFunctions.getDateDiffFormatted(this.clockInTimedatetime, DateFunctions.getDateTimeWithUTCOffset(dateNowin));
                    if (!this.clockRefresh) {
                        this.clockRefresh = timer(15000, 15000);
                        this.clockRefresh.subscribe(x => {
                            let dateNowin: Date = new Date(Date.now());
                            this.durationString = DateFunctions.getDateDiffFormatted(this.clockInTimedatetime, DateFunctions.getDateTimeWithUTCOffset(dateNowin));
                        });
                    }
                }
            }
            //this.sum = this.dataGrid.filter(item => item.tax  === '25.00').reduce((sum, current) => sum + current.total, 0);
            this.totalHrs = this.dataGrid
                .reduce((sum, current) => sum + current.hours, 0);
            this.saving = false;
            //this.UpdateTimeWorked();
        });
    }
    clockIn() {
        this.saving = true;
        let busObj: TimeEntryBus = new TimeEntryBus();
        //busObj.setFromForm(this.editForm.value);
        let dateNow: Date = new Date(Date.now());
        busObj.startTime = DateFunctions.getDateTimeWithUTCOffset(dateNow);
        busObj.personId = this.personId;

        this.svc_data.saveTimeEntry(busObj).subscribe(data => {
            this.clockedIn = true;
            this.durationString = "";

            this.getTimeEntries(); // put in here cuz get might return b4 async save is done
            this.timeEntryId = data.timeEntryId;
        });
    }
    clockOut() {
        this.saving = true;
        let dateNow: Date = new Date(Date.now());
        let busObj: TimeEntryBus = new TimeEntryBus();
        busObj.timeEntryId = this.timeEntryId;
        busObj.endTime =   DateFunctions.getDateTimeWithUTCOffset(dateNow);

        this.svc_data.saveTimeEntry(busObj).subscribe(data => {
            this.getTimeEntries(); // put in here cuz get might return b4 async save is done
            this.clockedIn = false;
            this.timeEntryId = null;
        });
    }
    public formatToUTCStringToLocalTime(inDate: Date): string {
        if (!inDate) return "";
        var calcDate = new Date(inDate);
        var utcDate = Date.UTC(calcDate.getFullYear(), calcDate.getMonth(), calcDate.getDate(), calcDate.getHours(), calcDate.getMinutes())
        return new Date(utcDate).toLocaleString('en-US', { year: '2-digit', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true });
    }
}
